<div class="gl-page">
  <small class="jobprocess-note">(This list is only available in test enviroments)</small>

  <!-- Back link -->
  <yds-button-back class="jpe-back" text="Ga terug 'Overzicht job(s)'" (back)="goBack()" />

  <!-- Title + page actions -->
  <div class="gl-page__header">
    <h1 class="gl-page__title">Job</h1>
    <div class="gl-page__header-actions">
      @if (!isAddMode()) {
        @if (detailsEditing()) {
          <yds-button variant="secondary" [disabled]="isSaving()" (click)="onResetToWaiting()">Reset job to Waiting</yds-button>
        }
        <yds-button variant="destructive" [disabled]="isRunning()" (click)="onDelete()">Verwijderen</yds-button>
      }
    </div>
  </div>

  @if (isLoading()) {
    <div class="gl-detail-loading">
      <yds-spinner [label]="'Job laden...'" />
    </div>
  } @else if (notFound()) {
    <p class="jpe-empty">Er zijn geen details voor job gevonden.</p>
  } @else {
    <yds-card-editable
      title="Details"
      [(editing)]="detailsEditing"
      [nextDisabled]="isSaving() || form.invalid"
      [nextLabel]="'Opslaan'"
      (cancel)="onDetailsCancel()"
      (next)="onDetailsNext()"
    >
      @if (detailsEditing()) {
        <form class="gl-form" [formGroup]="form">
          <p class="gl-form__required-hint">
            Velden gemarkeerd met een sterretje
            <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> zijn verplicht.
          </p>

          <div class="gl-field">
            <label class="gl-field__label">
              <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> execCmd
            </label>
            <div class="gl-field__control">
              <yds-dropdown
                formControlName="execCmd"
                [items]="jobNameOptions()"
                [allowClear]="false"
                [required]="true"
                [placeholder]="'Selecteer een job'"
              />
            </div>
          </div>

          <div class="gl-field">
            <label class="gl-field__label">
              <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> status
            </label>
            <div class="gl-field__control">
              <yds-dropdown
                formControlName="status"
                [items]="statusOptions"
                [allowClear]="false"
                [required]="true"
                [placeholder]="'Selecteer een status'"
              />
            </div>
          </div>

          <div class="gl-field">
            <label class="gl-field__label">notRestartable</label>
            <div class="gl-field__control">
              <yds-switch formControlName="notRestartable" />
            </div>
          </div>

          <div class="gl-field">
            <label class="gl-field__label">parameters</label>
            <div class="gl-field__control jpe-field--roomy">
              <yds-text-area formControlName="parameters" [rows]="4" [placeholder]="'Voer parameters in'" />
              <button
                type="button"
                class="jpe-copy"
                aria-label="Kopieer parameters"
                (click)="copyToClipboard(form.get('parameters')?.value)"
              >
                <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-copy" aria-hidden="true"></span>
              </button>
            </div>
          </div>

          <div class="gl-field">
            <label class="gl-field__label">tenantCode</label>
            <div class="gl-field__control">
              <yds-text-field formControlName="tenantCode" [type]="'number'" [placeholder]="'Voer een tenantcode in'" />
            </div>
          </div>

          <div class="gl-field">
            <label class="gl-field__label">
              <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> name
            </label>
            <div class="gl-field__control">
              <yds-text-field formControlName="name" [required]="true" [placeholder]="'Voer een naam in'" />
            </div>
          </div>

          <div class="gl-field">
            <label class="gl-field__label">description</label>
            <div class="gl-field__control">
              <yds-text-field formControlName="description" [placeholder]="'Voer een omschrijving in'" />
            </div>
          </div>

          <div class="gl-field">
            <label class="gl-field__label">result</label>
            <div class="gl-field__control jpe-field--roomy">
              <yds-text-area formControlName="result" [rows]="10" [placeholder]="'Voer een resultaat in'" />
              <button
                type="button"
                class="jpe-copy"
                aria-label="Kopieer result"
                (click)="copyToClipboard(form.get('result')?.value)"
              >
                <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-copy" aria-hidden="true"></span>
              </button>
            </div>
          </div>

          <hr class="jpe-separator" />

          @if (!isAddMode()) {
            <div class="gl-field">
              <label class="gl-field__label">jobProcessId</label>
              <div class="gl-field__control">
                <p class="gl-field__readonly-text">{{ displayValue(jobProcessId()) }}</p>
              </div>
            </div>
          }

          <div class="gl-field">
            <label class="gl-field__label">websiteInstanceId</label>
            <div class="gl-field__control">
              <yds-text-field formControlName="websiteInstanceId" [placeholder]="'Voer een website instance id in'" />
            </div>
          </div>

          <div class="gl-field">
            <label class="gl-field__label">user</label>
            <div class="gl-field__control">
              <yds-text-field formControlName="user" [placeholder]="'Voer een gebruiker in'" />
            </div>
          </div>

          <div class="gl-field">
            <label class="gl-field__label">errorMessage</label>
            <div class="gl-field__control jpe-field--roomy">
              <yds-text-area formControlName="errorMessage" [rows]="4" [placeholder]="'Voer een foutmelding in'" />
              <button
                type="button"
                class="jpe-copy"
                aria-label="Kopieer errorMessage"
                (click)="copyToClipboard(form.get('errorMessage')?.value)"
              >
                <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-copy" aria-hidden="true"></span>
              </button>
            </div>
          </div>

          @if (!isAddMode()) {
            <div class="gl-field">
              <label class="gl-field__label">lastRunned</label>
              <div class="gl-field__control jpe-datetime">
                <span class="gl-field__readonly-text">{{ formatDateTime(form.get('lastRunned')?.value) }}</span>
                <div class="jpe-datetime__actions">
                  <yds-button size="sm" (click)="setFieldNow('lastRunned')">Nu</yds-button>
                  <yds-button size="sm" variant="secondary" (click)="clearField('lastRunned')">Wissen</yds-button>
                </div>
              </div>
            </div>

            <div class="gl-field">
              <label class="gl-field__label">dateCreate</label>
              <div class="gl-field__control">
                <p class="gl-field__readonly-text">{{ formatDateTime(job()?.dateCreate ?? null) }}</p>
              </div>
            </div>

            <div class="gl-field">
              <label class="gl-field__label">dateStart</label>
              <div class="gl-field__control jpe-datetime">
                <span class="gl-field__readonly-text">{{ formatDateTime(form.get('dateStart')?.value) }}</span>
                <div class="jpe-datetime__actions">
                  <yds-button size="sm" (click)="setFieldNow('dateStart')">Nu</yds-button>
                  <yds-button size="sm" variant="secondary" (click)="clearField('dateStart')">Wissen</yds-button>
                </div>
              </div>
            </div>

            <div class="gl-field">
              <label class="gl-field__label">dateEnd</label>
              <div class="gl-field__control jpe-datetime">
                <span class="gl-field__readonly-text">{{ formatDateTime(form.get('dateEnd')?.value) }}</span>
                <div class="jpe-datetime__actions">
                  <yds-button size="sm" (click)="setFieldNow('dateEnd')">Nu</yds-button>
                  <yds-button size="sm" variant="secondary" (click)="clearField('dateEnd')">Wissen</yds-button>
                </div>
              </div>
            </div>
          }
        </form>
      } @else {
        <div class="gl-detail">
          <div class="gl-detail__row">
            <span class="gl-detail__label">execCmd</span>
            <span class="gl-detail__value">{{ displayValue(job()?.execCmd ?? null) }}</span>
          </div>
          <div class="gl-detail__row">
            <span class="gl-detail__label">status</span>
            <span class="gl-detail__value">{{ displayValue(job()?.status ?? null) }}</span>
          </div>
          <div class="gl-detail__row">
            <span class="gl-detail__label">notRestartable</span>
            <span class="gl-detail__value gl-detail__value--setting">
              @if (job()?.notRestartable) {
                <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-checkmark" aria-hidden="true"></span>
                <span>Ja</span>
              } @else {
                <span>Nee</span>
              }
            </span>
          </div>
          <div class="gl-detail__row">
            <span class="gl-detail__label">parameters</span>
            <span class="gl-detail__value gl-detail__value--memo jpe-detail-value">
              <span class="jpe-detail-text">{{ displayValue(job()?.parameters ?? null) }}</span>
              @if (job()?.parameters) {
                <button
                  type="button"
                  class="jpe-copy"
                  aria-label="Kopieer parameters"
                  (click)="copyToClipboard(job()?.parameters ?? null)"
                >
                  <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-copy" aria-hidden="true"></span>
                </button>
              }
            </span>
          </div>
          <div class="gl-detail__row">
            <span class="gl-detail__label">tenantCode</span>
            <span class="gl-detail__value">{{ displayValue(job()?.tenantCode ?? null) }}</span>
          </div>
          <div class="gl-detail__row">
            <span class="gl-detail__label">name</span>
            <span class="gl-detail__value">{{ displayValue(job()?.name ?? null) }}</span>
          </div>
          <div class="gl-detail__row">
            <span class="gl-detail__label">description</span>
            <span class="gl-detail__value">{{ displayValue(job()?.description ?? null) }}</span>
          </div>
          <div class="gl-detail__row">
            <span class="gl-detail__label">result</span>
            <span class="gl-detail__value gl-detail__value--memo jpe-detail-value">
              <span class="jpe-detail-text">{{ displayValue(job()?.result ?? null) }}</span>
              @if (job()?.result) {
                <button
                  type="button"
                  class="jpe-copy"
                  aria-label="Kopieer result"
                  (click)="copyToClipboard(job()?.result ?? null)"
                >
                  <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-copy" aria-hidden="true"></span>
                </button>
              }
            </span>
          </div>
          <hr class="jpe-separator" />
          <div class="gl-detail__row">
            <span class="gl-detail__label">jobProcessId</span>
            <span class="gl-detail__value">{{ displayValue(job()?.jobProcessId ?? null) }}</span>
          </div>
          <div class="gl-detail__row">
            <span class="gl-detail__label">websiteInstanceId</span>
            <span class="gl-detail__value">{{ displayValue(job()?.websiteInstanceId ?? null) }}</span>
          </div>
          <div class="gl-detail__row">
            <span class="gl-detail__label">user</span>
            <span class="gl-detail__value">{{ displayValue(job()?.user ?? null) }}</span>
          </div>
          <div class="gl-detail__row">
            <span class="gl-detail__label">errorMessage</span>
            <span class="gl-detail__value gl-detail__value--memo jpe-detail-value">
              <span class="jpe-detail-text">{{ displayValue(job()?.errorMessage ?? null) }}</span>
              @if (job()?.errorMessage) {
                <button
                  type="button"
                  class="jpe-copy"
                  aria-label="Kopieer errorMessage"
                  (click)="copyToClipboard(job()?.errorMessage ?? null)"
                >
                  <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-copy" aria-hidden="true"></span>
                </button>
              }
            </span>
          </div>
          <div class="gl-detail__row">
            <span class="gl-detail__label">lastRunned</span>
            <span class="gl-detail__value">{{ formatDateTime(job()?.lastRunned ?? null) }}</span>
          </div>
          <div class="gl-detail__row">
            <span class="gl-detail__label">dateCreate</span>
            <span class="gl-detail__value">{{ formatDateTime(job()?.dateCreate ?? null) }}</span>
          </div>
          <div class="gl-detail__row">
            <span class="gl-detail__label">dateStart</span>
            <span class="gl-detail__value">{{ formatDateTime(job()?.dateStart ?? null) }}</span>
          </div>
          <div class="gl-detail__row">
            <span class="gl-detail__label">dateEnd</span>
            <span class="gl-detail__value">{{ formatDateTime(job()?.dateEnd ?? null) }}</span>
          </div>
        </div>
      }
    </yds-card-editable>
  }
</div>
